import React from 'react';

import InOutHistoryUserUnregisteredContext from '../../services/inOutHistoryUserUnregistered/InOutHistoryUserUnregisteredContext';

import { SearchMenuHeader } from './SearchMenuHeader';
import { SelectBox } from '../../components/select/SelectBox';

import {
  UNREGISTERED_SEARCH_CCUS_SENT_STATUS_CONDENSED,
  UNIDENTIFIED_LOGS_AUTO_SEND,
} from '../../utilities/constants';

import Styles from '../../styles/componentStyle/inOutHistoryUserUnregistered/inOutHistoryUserUnregistered.scss';

/**
 * 不明な入退場データ検索フォーム
 * @props {string}propertyName:ステート内のプロパティ名
 * @TODO: 2019/12月リリース時点では検索機能には対応しない
 */
export class SearchForm extends React.Component {
  constructor(props) {
    super(props);
  }

  // 画面表示
  render() {
    return (
      <InOutHistoryUserUnregisteredContext.Consumer>
        {({
          state,
          searchFormHandle,
          clearSearchProperty,
          selectedSentStatus,
          selectedPriorCcusError,
          doSearch,
        }) => (
          <div className={`${Styles.search} master-slide-view__searchform`}>
            <div className='search-form'>
              <SearchMenuHeader
                total={state[this.props.propertyName].total}
                isOpened={state[this.props.propertyName].isOpened}
                accordionButtonClass={this.props.propertyName}
                clearButtonName={this.props.propertyName}
                searchFormHandle={() => {
                  searchFormHandle(this.props.propertyName);
                }}
                clearSearchProperty={() => {
                  clearSearchProperty(this.props.propertyName);
                }}
              />
              <div
                id='search-form-accordion'
                className={`${this.props.propertyName} ${
                  state[this.props.propertyName].isOpened
                    ? 'accordion show'
                    : 'accordion'
                }`}
              >
                <div className='search-form__body'>
                  <div className='form form--search-form'>
                    <div className='form__group flex-wrap'>
                      <div className='search-form-element'>
                        <div className='form form--date-dropdown-list'>
                          <div className='select-box__label'>
                            <span className='label'>
                              {data.searchTitle.date}
                            </span>
                          </div>
                          <div className='form__group'>
                            <div className='form-element'>
                              <div className='sys-form-calender'>
                                <div className='dropdown-calender'>
                                  <div className='dropdown-calender__input'>
                                    <input
                                      className='sys-dropdown-trigger sys-dropdown-trigger--force-down sys-name'
                                      type='text'
                                      name={`${[
                                        this.props.propertyName,
                                      ]}.fromDate`}
                                      value={
                                        state[this.props.propertyName].fromDate
                                      }
                                      onChange={() => null}
                                      autoComplete='off'
                                      readOnly
                                    />
                                    <div className='btn-spin'>
                                      <button className='btn-spin__up sys-calender-day-up'>
                                        <i className='i_arrow-top' />
                                      </button>
                                      <button className='btn-spin__down sys-calender-day-down'>
                                        <i className='i_arrow-bottom' />
                                      </button>
                                    </div>
                                  </div>
                                  <div className='dropdown'>
                                    <div className='dropdown-calender__calender' />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className='form-element'>
                              <p className='hyphen'>〜</p>
                            </div>
                            <div className='form-element'>
                              <div className='sys-form-calender'>
                                <div className='dropdown-calender'>
                                  <div className='dropdown-calender__input'>
                                    <input
                                      className='sys-dropdown-trigger sys-dropdown-trigger--force-down sys-name'
                                      type='text'
                                      name={`${[
                                        this.props.propertyName,
                                      ]}.toDate`}
                                      value={
                                        state[this.props.propertyName].toDate
                                      }
                                      onChange={() => null}
                                      autoComplete='off'
                                      readOnly
                                    />
                                    <div className='btn-spin'>
                                      <button className='btn-spin__up sys-calender-day-up'>
                                        <i className='i_arrow-top' />
                                      </button>
                                      <button className='btn-spin__down sys-calender-day-down'>
                                        <i className='i_arrow-bottom' />
                                      </button>
                                    </div>
                                  </div>
                                  <div className='dropdown'>
                                    <div className='dropdown-calender__calender' />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {state.unidentifiedLogsAutoSendFlg ===
                        UNIDENTIFIED_LOGS_AUTO_SEND.ON && (
                        <React.Fragment>
                          <div className='search-form-element'>
                            <SelectBox
                              label={data.searchTitle.sentStatus}
                              name={this.props.propertyName}
                              value={
                                state[this.props.propertyName]
                                  .selectedSentStatus
                              }
                              placeholder={data.selectedOptions.all}
                              items={
                                UNREGISTERED_SEARCH_CCUS_SENT_STATUS_CONDENSED
                              }
                              valueName='ID'
                              keyName='ID'
                              itemName='NAME'
                              onChange={event => {
                                selectedSentStatus(event);
                              }}
                            />
                          </div>
                          <div className='search-form-element prior-ccus-error'>
                            <label className='checkbox'>
                              <input
                                id='prior-ccus-error-enabled'
                                type='checkbox'
                                name='checkbox'
                                checked={state.searchForm.priorCcusError}
                                onChange={e => {
                                  selectedPriorCcusError(e.target.checked);
                                }}
                              />
                              <i className='i-square i-2x' aria-hidden='true' />
                              <span className='radio-search-span'>
                                {data.errorPriority}
                              </span>
                            </label>
                          </div>
                        </React.Fragment>
                      )}
                      <div className='search-form-element'>
                        <button
                          className='btn-fixedsize--stay search-form__btn'
                          onClick={() => doSearch()}
                        >
                          {data.searchButtonTitle}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </InOutHistoryUserUnregisteredContext.Consumer>
    );
  }
}

// 定数
const data = {
  errorPriority: 'CCUS送信エラーを優先して表示する',
  clearButtonTitle: '検索条件クリア',
  searchButtonTitle: '検索',
  searchTitle: {
    date: '期間',
    sentStatus: '送信状態',
  },
  selectedOptions: {
    all: 'すべて',
  },
};



// WEBPACK FOOTER //
// ./src/components/searchmenus/InOutHistoryUserUnregisteredSearch.jsx